import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        {/* Future project routes */}
        {/* <Route path="/projects/fit2" element={<FIT2 />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;